import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CopyButton } from '@interxfi/design-system/components/copy-button/copy-button';
import { ProgramBreadcrumb } from '../../../../../../../features/userauth/program/program-breadcrumb';
import { getProgramDetailPath } from '../../../../../../../features/userauth/program/program-routing';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_platform/_context-required/program/_program/$programId/_program')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `program-${params.programId}`,
        label: <ProgramBreadcrumb programId={params.programId} />,
        to: getProgramDetailPath(params.programId),
        suffix: <CopyButton content={params.programId} label="Copy Program ID" tooltip={{ copy: params.programId, copied: 'Copied Program ID' }} />,
      }),
    }) satisfies AggregateBreadcrumb,
  head: () => getPageHead('Program'),
});
